import React, { useEffect, useState } from 'react';
import { getdata } from "../../util/global";
import { deliverypartneritem, deliverypartneritemdef } from './Datatype';
import DeliveryPartnerTable from './DeliveryPartnerTable';
import DeliveryPartnerForm from './DeliveryPartnerForm';

const DeliveryPartner = () => {
  const [deliverypartners, setdeliverypartners] = useState<deliverypartneritem[]>([]);
  const [showmodal, setshowmodal] = useState("");
  const [formdata, setformdata] = useState<deliverypartneritem>(deliverypartneritemdef);

  const fetchdata = async () => {
    try {
      const res = await getdata({ filter: { datatype: "deliverypartnerdata" } });
      setdeliverypartners(res ? [...res].reverse() : []);
    } catch (err) {
      console.error(err);
    }
  };

  const openadd = () => {
    setformdata({ ...deliverypartneritemdef });
    setshowmodal("showdeliverypartnerform");
  };

  const openedit = (item: deliverypartneritem) => {
    setformdata({ ...item });
    setshowmodal("showdeliverypartnerform");
  };

  useEffect(() => {
    fetchdata();
  }, []);

  return (
    <div className="content-area">
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '16px' }}>
        <h3>Delivery Partners</h3>
        <button className="btn-blue" onClick={openadd}>+ Add Delivery Partner</button>
      </div>

      <DeliveryPartnerTable
        deliverypartners={deliverypartners}
        openedit={openedit}
      />
      <DeliveryPartnerForm
        showmodal={showmodal}
        setshowmodal={setshowmodal}
        formdata={formdata}
        setformdata={setformdata}
        fetchdata={fetchdata}
      />
    </div>
  );
};

export default DeliveryPartner;
